import { UsersApi } from '@evimo/client/apis';
import { createApiConfiguration } from '~/app/lib/api-config';

const config = createApiConfiguration();

export const usersApi = new UsersApi(config);

export const userRequestInit = { credentials: 'include' as const };
